<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12 text-center">
        <p>
          Possui alguma dúvida? Quer nos conhecer ou saber mais sobre nossos serviços?
          <br>
          Entre em contato conosco, será um prazer lhes atender!
        </p>

        <a href="/contato" class="mt-3 btn btn-main-sm">Entrar em contato</a>
      </div>
    </div>
  </div>
</template>

<script>
  export default {}
</script>